import { bffRequest } from "../../shared/api/bff-request";
import {
  FileDetails,
  ListResponse,
  PaginationRequestParams,
  SortingRequestParams,
} from "../../shared/types/api-types";

import type { NewsBannerVariant } from "./constants";
import { NewsItem, NewsSortColumn } from "./types";

export interface SearchNewsRequest {
  title?: string;
  briefText?: string;
  text?: string;
  projectIds?: string[];
  authorId?: string;
  lastUserEditedId?: string;
  sorting?: SortingRequestParams<NewsSortColumn>;
  pagination: PaginationRequestParams;
}

export const getNews = (id: string) =>
  bffRequest.get<NewsItem>(`/news/item?id=${id}`);

export const getNewsList = (body: SearchNewsRequest) =>
  bffRequest.post<ListResponse<NewsItem>>("/news/list", body);

interface GetNewsBannerRequest {
  newsId: string;
  fileName: string;
  variant?: NewsBannerVariant;
}

export const getNewsBanner = ({
  newsId,
  fileName,
  variant,
}: GetNewsBannerRequest) =>
  bffRequest
    .get<Blob>(
      `/news/file?${createNewsBannerQuery({ newsId, fileName, variant })}`,
      {
        responseType: "blob",
      },
    )
    .catch(() => null);

export const getNewsBannerDetails = (news: NewsItem): FileDetails | null =>
  news.banner;

const createNewsBannerQuery = ({
  newsId,
  fileName,
  variant,
}: GetNewsBannerRequest) => {
  const searchParams = new URLSearchParams({
    newsId,
    fileName,
  });

  if (variant) {
    searchParams.set("variant", variant);
  }

  return searchParams.toString();
};
